import styled from "@emotion/styled";
import {Link} from "react-router-dom";

const success = "#5cb85c";
const warning = "#f0ad4e";
const dangerRed = "#ff5f5f";
const neutral = "#003b00";

const color = props => {
  if (props.danger) {
    return dangerRed;
  } else if (props.success) {
    return success;
  } else if (props.warning) {
    return warning;
  }
  return neutral;
};

const Button = styled.button`
  display: flex;
  gap: 5px;
  font-family: "IBM Plex Mono";
  font-size: ${props => (props.large ? "1.25rem" : "1rem")};
  border: 2px solid ${props => color(props)};
  font-weight: 700;
  background-color: ${props => (props.primary ? props.theme.newGreen : "transparent")};
  color: ${props => color(props)};
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  padding: 0.5em 0.75em;

  &:hover {
    background-color: ${props => props.theme.newGreen};
    color: ${props => (props.type === "danger" ? "white" : "initial")};
  }

  &:disabled {
    cursor: not-allowed !important;
    pointer-events: none;
    background-color: #fff;
    opacity: 0.5;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
  }
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #242424;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }
  input:checked + .slider {
    background-color: #007c41;
  }
  input:focus + .slider {
    box-shadow: 0 0 1px #007c41;
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
`;

const AnchorButton = Button.withComponent("a");
const LinkButton = Button.withComponent(Link);

const TransparentButton = styled(Button)`
  border-color: transparent;
  background-color: transparent;

  &:hover {
    border-color: ${({theme}) => theme.almostBlack};
  }
`;

export {AnchorButton, LinkButton, TransparentButton};
export default Button;
